import { useState, useEffect } from "react";
import { getSeriesWidget } from "../api/widgets/series/requests";

function useStoryblokSeriesWidget() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getSeriesWidget()
      .then((data) => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => setIsLoading(false));
  }, []);

  return [data, isLoading];
}

export { useStoryblokSeriesWidget };
